module.exports = __webpack_public_path__ + "img/boards-sprite.acefb090.png";